import { AxiosResponse } from 'axios';
import { SET_MINYANS_N, SET_MINYAN_N, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_MINYAN_N_ISLOADING,
  DELETE_MINYAN_N,
  EDIT_MINYAN_N,
  GET_MINYAN_N,
  GET_MINYANS_N,
  REGISTER_MINYAN_N,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Minyan_N from '@/services/minyan_N';
import { Module } from 'vuex';
import { EditMinyan_N, RegisterMinyan_N, GetMinyan_N } from '@/dtos/minyan_N.dto';

const minyan_N: Module<any, {}> = {
  state: {
    minyan_N: {
      data: null,
      isLoading: false,
    },
    minyans_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    minyan_N: (state: { minyan_N: any }) => state.minyan_N,
    minyans_N: (state: { minyans_N: any }) => state.minyans_N,
  },
  mutations: {
    [SET_MINYAN_N]: (
      state: { minyan_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyan_N.data = payload.data) : null,
        (state.minyan_N.isLoading = payload.isLoading);
    },
    [SET_MINYANS_N]: (
      state: { minyans_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyans_N.data = payload.data) : null,
        (state.minyans_N.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_MINYAN_N]: async ({ commit }: any, payload: RegisterMinyan_N) => {
      commit(SET_MINYAN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyan_N.registerMinyan_N(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MINYAN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_N, { isLoading: false });
        return false;
      }
    },
    [GET_MINYANS_N]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANS_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyan_N.getMinyans_N(
        payload as GetMinyan_N
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANS_N, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_MINYANS_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANS_N, { isLoading: false });
        return false;
      }
    },
    [GET_MINYAN_N]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYAN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyan_N.getMinyans_N(
        payload as GetMinyan_N
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_N, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_MINYAN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_N, { isLoading: false });
        return false;
      }
    },
    [EDIT_MINYAN_N]: async ({ commit }: any, payload: EditMinyan_N) => {
      commit(SET_MINYAN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyan_N.editMinyan_N(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_N, { isLoading: false });
        return false;
      }
    },
    [DELETE_MINYAN_N]: async ({ commit }: any, payload: string) => {
      commit(SET_MINYAN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyan_N.deleteMinyan_N(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYAN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYAN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYAN_N, { isLoading: false });
        return false;
      }
    },
    [CLEAR_MINYAN_N_ISLOADING]: ({ commit }) => {
      commit(SET_MINYAN_N, { isLoading: false });
      commit(SET_MINYANS_N, { isLoading: false });
    },
  },
};

export default minyan_N;

